import React, { FC } from 'react';
import Safe from 'react-safe';

export const ZendeskScript: FC<{}> = () => (
  <Safe.script>
    {`
            (function () { 
                function loadZdBot() {
									setTimeout(function() {
                    var s = document.createElement('script');
                    s.id = 'ze-snippet'; 
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = 'https://static.zdassets.com/ekr/snippet.js?key=19721739-8313-4209-bd92-fb082eac2701';
                    var x = document.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);

                    window.zESettings = {
                      webWidget: {
                        offset: {
                          mobile: {
                            horizontal: 'left'
                          }
                        }
                      }
                    };

                  }, 5000);
                }
                loadZdBot();
            })();
          `}
  </Safe.script>
);
